import { takeLatest, fork, select, call, all } from 'redux-saga/effects';
import { ReduxStore } from '../payload-types';
import { QUOTE_INDIVIDUAL_REQUEST_START } from '../quote';
import { prepareQuote } from '../request.mappers';
import axios from 'axios';
import { get } from 'lodash';
import { LINKS } from '@trip-ux/constants';
import locations from '../destination/sagas';
import organizationSaga from '../organization/sagas';
import reportOrganization from '../report/sagas';
import agencyOrganization from '../agency/sagas';

const updateQuote = (state: ReduxStore) =>
  state.config.isAdmin
    ? Promise.resolve()
    : axios.post(`${get(state, 'config.options.contextPath', '')}${LINKS.SYNC_QUOTE_FORM}`, {
        payload: prepareQuote(state),
        form: state.quoteForm.form
      });

function* syncQuote() {
  const state: ReduxStore = yield select((store: ReduxStore) => store);
  yield call(updateQuote, state);
}

function* watchSyncQuote() {
  yield takeLatest(QUOTE_INDIVIDUAL_REQUEST_START, syncQuote);
}

export default function* rootSaga() {
  yield all([fork(watchSyncQuote), ...locations, ...organizationSaga, ...reportOrganization, ...agencyOrganization]);
}
